/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_TranscriptionInputs */

const en_batch_transcription = /** @type {(inputs: Batch_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batch Transcription`)
};

const fr_batch_transcription = /** @type {(inputs: Batch_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription par lot`)
};

const de_batch_transcription = /** @type {(inputs: Batch_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stapeltranskription`)
};

const it_batch_transcription = /** @type {(inputs: Batch_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizione in batch`)
};

const ru_batch_transcription = /** @type {(inputs: Batch_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пакетная транскрипция`)
};

const es_batch_transcription = /** @type {(inputs: Batch_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcripción por lotes`)
};

const zh_cn2_batch_transcription = /** @type {(inputs: Batch_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量转录`)
};

const ja_batch_transcription = /** @type {(inputs: Batch_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バッチ転写`)
};

const hi_batch_transcription = /** @type {(inputs: Batch_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैच प्रतिलेखन`)
};

const pt_pt2_batch_transcription = /** @type {(inputs: Batch_TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcrição em lote`)
};

/**
* | output |
* | --- |
* | "Batch Transcription" |
*
* @param {Batch_TranscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_transcription = /** @type {((inputs?: Batch_TranscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_TranscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_transcription(inputs)
	if (locale === "de") return de_batch_transcription(inputs)
	if (locale === "it") return it_batch_transcription(inputs)
	if (locale === "ru") return ru_batch_transcription(inputs)
	if (locale === "es") return es_batch_transcription(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_transcription(inputs)
	if (locale === "ja") return ja_batch_transcription(inputs)
	if (locale === "hi") return hi_batch_transcription(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_transcription(inputs)
	return en_batch_transcription(inputs)
});